(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("expoll", [], factory);
	else if(typeof exports === 'object')
		exports["expoll"] = factory();
	else
		root["expoll"] = factory();
})(self, () => {
return 